import TableCell from "@mui/material/TableCell";

export const Cell = ({ children, ...props}) => {
    return (
        <TableCell >
            {children}
        </TableCell>
    );
};

export default Cell;